
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"17","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.986.932h-1.87A2.681 2.681 0 008.085 0h-2.69c-.81 0-1.537.362-2.03.932h-1.87C.67.932 0 1.603 0 2.429v13.074C0 16.328.67 17 1.494 17h10.492c.824 0 1.494-.672 1.494-1.497V2.429c0-.826-.67-1.497-1.494-1.497zm-6.59.066h2.689c.77 0 1.409.515 1.619 1.198H3.777A1.698 1.698 0 015.396.998zm7.088 14.505a.5.5 0 01-.498.499H1.494a.5.5 0 01-.498-.5V2.43a.5.5 0 01.498-.5h1.323a2.69 2.69 0 00-.111.766c0 .275.223.499.498.499h7.072a.499.499 0 00.498-.5c0-.265-.039-.522-.11-.764h1.322a.5.5 0 01.498.499v13.074z"}}),_c('path',{attrs:{"d":"M4.285 9.916l-.732.734-.18-.18a.497.497 0 10-.704.706l.532.532c.194.195.51.195.704 0l1.085-1.086a.5.5 0 00-.705-.706zM10.426 10.313H6.408a.499.499 0 000 .998h4.018a.499.499 0 000-.998zM4.285 12.777l-.732.734-.18-.18a.497.497 0 10-.704.706l.532.532c.194.195.51.195.704 0l1.085-1.086a.5.5 0 00-.705-.706zM10.426 13.174H6.408a.499.499 0 000 .998h4.018a.499.499 0 000-.998zM7.69 8.004l1.54-1.543v.06a.499.499 0 10.997 0c0-1.412.002-1.28-.006-1.336a.498.498 0 00-.493-.428H8.467a.499.499 0 000 .998h.06l-1.19 1.19-1.506-1.51a.497.497 0 00-.705 0L3.333 7.233a.5.5 0 00.705.706l1.44-1.444 1.508 1.51c.194.195.51.195.704 0z"}})])
          )
        }
      }
    